import { ProCard } from '@components'
import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'
import styles from './SectionCard.module.scss'

interface Props {
  icon?: ReactNode
  title: ReactNode
  description?: ReactNode
  /** Header-right content: a status badge, a feature switch or an action. */
  aside?: ReactNode
  className?: string
  children?: ReactNode
  'data-test'?: string
}

/** A titled settings-style card: icon tile, title and description, optional aside, then the section body. */
function SectionCard({ icon, title, description, aside, className, children, ...props }: Props) {
  return (
    <ProCard className={cn('section-card', className)} {...props}>
      <div className={cn(styles['section-card__head'], 'section-card__head')}>
        {icon && <span className={cn(styles['section-card__icon'], 'section-card__icon')}>{icon}</span>}
        <div className={cn(styles['section-card__titles'], 'section-card__titles')}>
          <h2 className={cn(styles['section-card__title'], 'section-card__title')}>{title}</h2>
          {description && (
            <p className={cn(styles['section-card__description'], 'section-card__description')}>{description}</p>
          )}
        </div>
        {aside && <div className={cn(styles['section-card__aside'], 'section-card__aside')}>{aside}</div>}
      </div>
      {children}
    </ProCard>
  )
}

export default SectionCard
